export const formStyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  flexGrow: 1,
};

export const wrapperStyles = {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
};
